import { VolumeDriverApi } from '@app/services/volume-driver-service/volume-driver.service';
import { DEFAULT_PAGINATION_PAGE_LIMIT } from '@app/shared/components/AppTablePagination/consts';
import { throttleEffect } from '@app/shared/utils/sagaUtils/sagaUtils';
import { enqueSnackAction } from '@app/store/snacks';
import { call, put } from 'redux-saga/effects';
import {
  createSystemConfigurationAction,
  fetchVolumeDriverConfigurationsDataAction,
  setNameExsitsAction,
  setVolumeSystemConfigurationsCreatingAction,
  setVolumeSystemConfigurationsModalOpenedAction,
} from '../actions';

export function* createrVolumeSystemConfigurationSaga(
  action: ReturnType<typeof createSystemConfigurationAction>
) {
  const {
    name,
    description,
    firstLevel,
    secondLevel,
    thirdLevel,
    fourthLevel,
    fifthLevel,
    unit,
  } = action;

  try {
    yield put(setVolumeSystemConfigurationsCreatingAction({ creating: true }));
    yield throttleEffect(
      yield call(VolumeDriverApi.createVolumeSystemConfiguration, {
        name,
        unit,
        description,
        firstLevel,
        secondLevel,
        thirdLevel,
        fourthLevel,
        fifthLevel,
      })
    );
    yield put(setVolumeSystemConfigurationsCreatingAction({ creating: true }));
    yield put(
      setVolumeSystemConfigurationsModalOpenedAction({ opened: false })
    );
    yield put(
      fetchVolumeDriverConfigurationsDataAction({
        skip: 0,
        limit: DEFAULT_PAGINATION_PAGE_LIMIT,
      })
    );
    yield put(setVolumeSystemConfigurationsCreatingAction({ creating: false }));
    yield put(setNameExsitsAction({ payload: false }));
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Volume system configuration has been created.',
          options: {
            variant: 'success',
          },
          key: 'volume-system-configuration-create-success',
        },
      })
    );
  } catch (e) {
    yield put(setVolumeSystemConfigurationsCreatingAction({ creating: false }));
    if (e.response && e.response.status === 409) {
      yield put(setNameExsitsAction({ payload: true }));
      yield put(
        enqueSnackAction({
          notification: {
            message:
              'Volume System configuration with provided name already exists, please try again.',
            options: {
              variant: 'warning',
            },
            key: 'volujme-system-configuration-create-failed',
          },
        })
      );
    } else {
      yield put(
        enqueSnackAction({
          notification: {
            message: 'Failed to create Volume System configuration',
            options: {
              variant: 'error',
            },
            key: 'volujme-system-configuration-create-failed',
          },
        })
      );
    }
  }
}
